import { render, staticRenderFns } from "./Tagify.vue?vue&type=template&id=2bea68f6&scoped=true&"
import script from "./Tagify.vue?vue&type=script&lang=js&"
export * from "./Tagify.vue?vue&type=script&lang=js&"
import style0 from "./Tagify.vue?vue&type=style&index=0&id=2bea68f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bea68f6",
  null
  
)

export default component.exports